export const DESIGN_STORAGE_KEY = 'comet_designs';

export function toDesignNode(n) {
  return {
    id: n.id,
    type: n.type ?? 'resource-group',
    position: n.position,
    data: n.data,
    parentId: n.parentId,
    extent: n.extent === 'parent' ? 'parent' : undefined,
    style: n.style
      ? {
          width: typeof n.style.width === 'number' ? n.style.width : undefined,
          height: typeof n.style.height === 'number' ? n.style.height : undefined,
        }
      : undefined,
  };
}

export function toDesignEdge(e) {
  return {
    id: e.id,
    source: e.source,
    target: e.target,
    type: e.type,
    label: typeof e.label === 'string' ? e.label : undefined,
  };
}
